export default __webpack_public_path__ + "static/media/XWidget.39ce4a63.png";